import { render } from "./geo-limit-currency-configuration.vue?vue&type=template&id=5f6d86bc&ts=true"
import script from "./geo-limit-currency-configuration.ts?vue&type=script&lang=ts"
export * from "./geo-limit-currency-configuration.ts?vue&type=script&lang=ts"

import "./geo-limit-currency-configuration.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__